module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-container"
  }, [_c('div', {
    staticClass: "data-container"
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "110px",
      "rules": _vm.addFormRules
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "公司名称",
      "prop": "companyName"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "请输入公司名称"
    },
    model: {
      value: (_vm.addForm.companyName),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "companyName", $$v)
      },
      expression: "addForm.companyName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户姓名",
      "prop": "customerName"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "请输入客户姓名",
      "disabled": ""
    },
    model: {
      value: (_vm.addForm.customerName),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "customerName", $$v)
      },
      expression: "addForm.customerName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": "联系方式",
      "prop": "phoneNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": "11",
      "show-word-limit": "",
      "auto-complete": "off",
      "placeholder": "请输入客户手机号"
    },
    on: {
      "blur": _vm.checkCustomer
    },
    model: {
      value: (_vm.addForm.phoneNumber),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "phoneNumber", $$v)
      },
      expression: "addForm.phoneNumber"
    }
  }), _vm._v(" "), (_vm.showPhoneNumberWarning) ? _c('span', {
    staticClass: "el-form-item__error"
  }, [_vm._v(_vm._s(_vm.phoneNumberWarningMessage))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, _vm._l((_vm.addForm.telPhone), function(telPhone, index) {
    return _c('el-form-item', {
      key: index,
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "label": index === 0 ? '客户电话' : ''
      }
    }, [_c('el-input', {
      attrs: {
        "auto-complete": "off",
        "placeholder": "请输入客户电话"
      },
      model: {
        value: (_vm.addForm.telPhone[index]),
        callback: function($$v) {
          _vm.$set(_vm.addForm.telPhone, index, $$v)
        },
        expression: "addForm.telPhone[index]"
      }
    }), _vm._v(" "), (index === _vm.addForm.telPhone.length - 1) ? _c('el-button', {
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          return _vm.addInput(index)
        }
      }
    }, [_vm._v("新增输入框")]) : _vm._e(), _vm._v(" "), (index > 0) ? _c('el-button', {
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          return _vm.removeInput(index)
        }
      }
    }, [_vm._v("移除")]) : _vm._e()], 1)
  }), 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户微信",
      "prop": "customerWx"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "请输入客户微信"
    },
    model: {
      value: (_vm.addForm.customerWx),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "customerWx", $$v)
      },
      expression: "addForm.customerWx"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "所属地区",
      "prop": "area"
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "options": _vm.pcaTextArr,
      "clearable": ""
    },
    model: {
      value: (_vm.addForm.area),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "area", $$v)
      },
      expression: "addForm.area"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "详细地址",
      "prop": "address"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "auto-complete": "off",
      "placeholder": "请输入客户详细地址"
    },
    model: {
      value: (_vm.addForm.address),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "address", $$v)
      },
      expression: "addForm.address"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户级别",
      "prop": "labelId"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请选择客户级别"
    },
    model: {
      value: (_vm.addForm.labelId),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "labelId", $$v)
      },
      expression: "addForm.labelId"
    }
  }, _vm._l((_vm.custoLabel), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.customerLabel,
        "value": item.id
      }
    }, [_c('span', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v(_vm._s(item.customerLabel))])])
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户来源",
      "prop": "sourceId"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请选择客户来源"
    },
    model: {
      value: (_vm.addForm.sourceId),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "sourceId", $$v)
      },
      expression: "addForm.sourceId"
    }
  }, _vm._l((_vm.custoSource), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.customerSource,
        "value": item.id
      }
    }, [_c('span', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v(_vm._s(item.customerSource))])])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户销售渠道",
      "prop": "typeId"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请选择销售渠道"
    },
    model: {
      value: (_vm.addForm.typeId),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "typeId", $$v)
      },
      expression: "addForm.typeId"
    }
  }, _vm._l((_vm.custoType), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.customerType,
        "value": item.id
      }
    }, [_c('span', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v(_vm._s(item.customerType))])])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "添加图片"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "name": "file",
      "action": this.$uploadURL,
      "on-remove": _vm.handleFileRemove,
      "on-success": _vm.handleFileUpload,
      "on-exceed": _vm.handleFileExceed,
      "file-list": _vm.fileList,
      "limit": 5,
      "multiple": true,
      "accept": ".jpg,.png,.gif",
      "list-type": "picture"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("点击上传")])], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "备注信息",
      "prop": "notes"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "textarea",
      "rows": 2,
      "auto-complete": "off",
      "placeholder": "请输入备注信息"
    },
    model: {
      value: (_vm.addForm.notes),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "notes", $$v)
      },
      expression: "addForm.notes"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit($event)
      }
    }
  }, [_vm._v("创建客户")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-667d4017"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/customerMag/OrderToAddCustomer.vue
// module id = 1017
// module chunks = 3